export class NgCkEditorService {
	constructor($q) {
     'ngInject';
    
      this.$defer = $q.defer();
	}
    
	setLoaded() {
        this.$defer.resolve();
	}
    
    getLoaded() {
        return this.$defer.promise;
    }
}


// WEBPACK FOOTER //
// ./src/app/common/libs/ng-ckeditor/ng-ckeditor.service.js